import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=36745d2c&scoped=true&"
import script from "./RefundPolicy.vue?vue&type=script&lang=ts&"
export * from "./RefundPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=36745d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36745d2c",
  null
  
)

export default component.exports